export default __webpack_public_path__ + "static/media/library-3.ad4059ae.webp";